export const BaseBondkitTokenFactoryContractAddress = "0x5d641bbB206d4B5585eCCd919F36270200A9A2Ad";
export const BaseMainnetRpcUrl = "https://base-rpc.publicnode.com";
// Uniswap V4 addresses on Base
export const UniversalRouterAddress = "0x6ff5693b99212da76ad316178a184ab56d299b43";
export const QuoterAddress = "0x0d5e0f971ed27fbff6c2837bf31316121532048d";
export const Permit2Address = "0x000000000022D473030F116dDEE9F6B43aC78BA3";
export const B3TokenAddress = "0xB3B32F9f8827D4634fE7d973Fa1034Ec9fdDB3B3";
